import React from 'react';

import LinkIcon from '@atlaskit/icon/core/link';

import { ProductKeys } from '../../constants/product-keys';
import { type ProductConfigs, useProductConfigs } from '../../constants/products';

export const FederatedIcon = ({
	productConfigs,
	...props
}: {
	product?: string;
	resourceType?: string;
	productConfigs?: ProductConfigs;
}): React.JSX.Element => {
	return productConfigs ? (
		<FederatedIconWithProductConfigs {...props} productConfigs={productConfigs} />
	) : (
		<FederatedIconWithLocalProductConfigs {...props} />
	);
};

type FederatedIconProps = {
	product?: string;
	resourceType?: string;
};

const FederatedIconWithLocalProductConfigs = (props: FederatedIconProps): React.JSX.Element => {
	const productConfigs = useProductConfigs();

	return <FederatedIconWithProductConfigs {...props} productConfigs={productConfigs} />;
};

const FederatedIconWithProductConfigs = ({
	product,
	resourceType,
	productConfigs,
}: FederatedIconProps & { productConfigs: ProductConfigs }): React.JSX.Element => {
	let productKey;
	if (product === 'google' && resourceType === 'email') {
		productKey = ProductKeys.Gmail;
	} else if (product === 'microsoft' && resourceType === 'email') {
		productKey = ProductKeys.OutlookMail;
	}

	if (!productKey) {
		return <LinkIcon color="currentColor" spacing="spacious" label="" />;
	}

	let IconComponent = productConfigs[productKey]?.SearchResultIcon;
	return IconComponent ? (
		// 32px, the search result icon size shared with IconFor3P. Passing no size would fall back
		// to the product config's own default of 'large', a legacy spelling of 32px that the old
		// bucket scale clamped; on the accurate scale 'large' is really 40px.
		<IconComponent label="" size="medium" />
	) : (
		<LinkIcon color="currentColor" spacing="spacious" label="" />
	);
};
